<template>
  <div>
    <v-container>
      <v-col offset-md="3" :md="6">
        <div v-if="newPool"><h1 class="text-center primary--text mb-n3">Create New Pool</h1></div>
        <div v-else><h1 class="text-center primary--text mb-n3">Edit Pool</h1></div>
        <v-col offset-md="4" :md="4">
          <v-switch v-model="newPool" ref="new" label="Create New" @change="createNew"></v-switch>
        </v-col>
        <div v-if="!newPool">
          <v-select v-model="poolId" ref="poolId" @change="poolChange"
            :items="ownPools" item-text="poolName" item-value="poolId"
            label="Choose Pool">
          </v-select>
        </div>
        <div v-if="newPool || poolId != 0">
          <v-select v-model="sportId" ref="sportId"
            :items="sportList" item-text="sportName" item-value="sportId"
            label="Sport" @change="sportChange">
          </v-select>
          <v-select v-model="tourId" ref="tourId"
            :items="sportTourList" item-text="tournamentName" item-value="tournamentId"
            label="Tournament">
          </v-select>
          <v-text-field v-model="poolName" ref="poolName" label="Pool Name" />
          <v-textarea rows="1" auto-grow v-model="poolDesc" 
                label="Pool Description" ref="poolDesc" />
          <v-text-field type="date" v-model="endDate" ref="endDate" label="Entry End Date" />
          <v-card v-if="bpLength > 0">
            <v-list color="white" dense>
              <v-subheader>Select Bonus Points</v-subheader>
              <v-list-item-group>
                <v-list-item v-for="(bonus, index) in bonusPointList" :key="index" color="primary">
                  <template v-slot>
                    <v-list-item-action>
                      <v-checkbox v-model="bpList[index]" 
                        color="primary">
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title @click="bpList[index] = !bpList[index]" v-text="bonus.bonusName"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
          <v-row class="mt-5">
            <v-btn color="error" outlined to="/">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="savePool">Save</v-btn>
          </v-row>
        </div>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'pool',
  computed: {
    ...mapGetters([
      'ownPools', 'ownPoolsLoaded', 
      'sportList', 'sportTourList', 
      'bonusPointList', 'bonusPointLoaded'
    ])
  },
  data: () => ({
    newPool: false,
    poolId: 0,
    sportId: 0,
    tourId: 0,
    poolName: '',
    poolDesc: '',
    endDate: '',
    bpList: [],
    bpLength: 0
  }),
  watch: {
    bonusPointLoaded: function() {
      this.bpLength = this.bonusPointList.length
      this.bpList.splice(0)
      var objMatch = this.ownPools.find( elem => elem.poolId == this.poolId )
      if (this.bpLength > 0) {
        for (var i = 0; i < this.bpLength; i++) {
          if (objMatch) {
            var objFound = objMatch.bonusUsed.findIndex(elem => elem == this.bonusPointList[i].bonusId )
            this.bpList[i] =  ( objFound != -1) ? true : false
          } else {
            this.bpList.push(false)
          }
        }
      }
    }
  },
  created() {
    this.$store.dispatch('getOwnPools')
    this.$store.dispatch('getSportList')
  },
  methods: {
    bpIcon(val) {
      if (val) {
        return 'mdi-check-circle'
      } else {
        return 'mdi-plus'
      }
    },
    poolChange() {
      if (this.poolId == 0) {
        return
      }
      var objMatch = this.ownPools.find( elem => elem.poolId == this.poolId )
      if (objMatch) {
        this.sportId = objMatch.sportId
        this.sportChange()
        this.tourId = objMatch.tournamentId
        this.poolName = objMatch.poolName
        this.poolDesc = objMatch.poolDesc
        this.endDate = objMatch.entryEndDate.substring(0, 10)
      }
    },
    createNew() {
      if (this.newPool) {
        this.poolId = 0
        this.sportId = 0
        this.tourId = 0
        this.poolName = ''
        this.poolDesc = ''
        this.endDate = ''
        this.bpList.splice(0)
      }
    },
    sportChange() {
      this.$store.dispatch('getSportTourList', this.sportId)
      this.$store.dispatch('getBonusPointList', this.sportId)
    },
    checkFields() {
      if (this.sportId == 0) {
        alert("Choose a Sport")
        this.$refs.sportId.focus()
        return false
      }
      if (this.tourId == 0) {
        alert("Choose a Tournament")
        this.$refs.tourId.focus()
        return false
      }
      this.poolName.trim()
      if (this.poolName == '') {
        alert("Enter the Pool Name")
        this.$refs.poolName.focus()
        return false
      }
      this.poolDesc.trim()
      if (this.poolDesc == '') {
        alert("Enter Pool description")
        this.$refs.poolDesc.focus()
        return false
      }
      if (this.endDate == '') {
        alert("Enter Entry End Date")
        this.$refs.endDate.focus()
        return false
      }
      return true
    },
    savePool() {
      if (!this.checkFields()) {
        return
      }
      var bonusUsed = []
      for (var i=0; i<this.bonusPointList.length; i++) {
        if (this.bpList[i]) {
          bonusUsed.push(this.bonusPointList[i].bonusId)
        }
      }
      var poolObject = {
        poolName: this.poolName,
        poolDesc: this.poolDesc,
        tournamentId: this.tourId,
        entryEndDate: this.endDate,
        bonusUsed: bonusUsed
      }
      const token = this.$store.getters.authToken
      if (token) {
        const header = { 'Content-type': 'application/json', 'x-auth': token }
        axios.post('/api/userPool/new', JSON.stringify(poolObject), { headers: header })
        .then(() => {
          this.$store.dispatch('getOwnPools')
        })
        .catch(err => {
          alert(err.response.data.err)
        })
      }
    }
  },
}
</script>